export default "__VITE_ASSET__0899e875__"